export default "__VITE_ASSET__zDEaHYh2__"